export enum ProductOnboardingStep {
  AccountActivated = 'accountActivated',
  AvatarUploaded = 'avatarUploaded',
  CodeInstalled = 'codeInstalled',
  DesktopAppDownloaded = 'desktopAppDownloaded',
  SampleChat = 'sampleChat',
  InviteTeammates = 'inviteTeammates',
  InstallMessenger = 'installMessenger',
  InstallWhatsApp = 'installWhatsApp',
  InstallTwilio = 'installTwilio',
  InstallTelegram = 'installTelegram',
  CustomizeWidget = 'customizeWidget',
  ChatbotChat = 'chatbotChat',
  CopilotChat = 'copilotChat',
  SetupCampaigns = 'setupCampaigns',
  SetupCannedResponses = 'setupCannedResponses',
  AddChannels = 'addChannels',

  /**
   * This step is not present in REST API so it must be excluded from IProductOnboardingProgress type
   */
  SetupChatbot = 'setupChatbot',
  SetupMessenger = 'setupMessenger',
  SetupWhatsApp = 'setupWhatsApp',
  SetupTwilio = 'setupTwilio',
  SetupTelegram = 'setupTelegram',
}

export interface IProductOnboardingProgress
  extends Record<
    Exclude<
      ProductOnboardingStep,
      | ProductOnboardingStep.SetupChatbot
      | ProductOnboardingStep.SetupMessenger
      | ProductOnboardingStep.SetupWhatsApp
      | ProductOnboardingStep.SetupTwilio
      | ProductOnboardingStep.SetupTelegram
    >,
    boolean
  > {}
